export default __webpack_public_path__ + "static/header-signup-f8e910a387f163409146f42957d55413.png";